export function stripRouteHashFromOrderId(orderId: string, splitSymbol = '#'): number {
    if (orderId.indexOf(splitSymbol) === -1) {
        return Number(orderId);
    }

    const splitSymbolIndex = orderId.indexOf(splitSymbol);
    const orderIdWithoutHash = orderId.substring(0, splitSymbolIndex);
    return stripRouteHashFromOrderId(orderIdWithoutHash, '?');
}
